import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import { Envelope, Telephone, Geo } from "react-bootstrap-icons";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import "../css/help-module.css";

export const Contacts = () => {

    return (
        <>
            <Col>
                <Row className="pb-10">
                    <h1 style={{ paddingTop: "20px", marginLeft: '30px' }} >
                        <SVG
                            src={toAbsoluteUrl('/media/svg/icons/Communication/Active-call.svg')}
                            style={{ width: "40px", height: "40px", transform: "scaleX(-1)" }}
                        /> {" "}
                        Contact our Helpdesk
                    </h1>
                </Row>
                <Row>
                    <Col lg={8} md={12} sm={12} className="pt-5">
                        <Card className="border-0">
                            <Card.Body className="cardBodyMobilePadding">
                                <Row>
                                    <Col lg={4} md={12} sm={12} className="pb-5 d-flex justify-content-center">
                                        <img alt="DoF Logo" src='media/logos/png-emblem-DOF.png' style={{ width: "100%", height: "100%" }} />
                                    </Col>
                                    <Col lg={8} md={12} sm={12}>
                                        <h5 className="card-title" style={{ "fontSize": "20px" }}> <b>E-Receipting System Support Center</b> </h5>
                                        <p className="card-text" style={{ "fontSize": "18px" }}>
                                            Department of Finance  <br />
                                            <Telephone /> &nbsp; (+675) 301 1422 / 301 1421 &nbsp; <br /> <Envelope /> &nbsp; epaysupport@finance.gov.pg <br />
                                            <br />
                                            <a href="https://maps.app.goo.gl/zpoHqYi3BnMAohzW6" rel="noopener noreferrer" target="_blank" title="Google Map location"><Geo /></a> Twin Tower 1<br />
                                            Melanesian Way, Waigani <br />
                                            Port Moresby, National Capital District<br />
                                        </p>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col lg={4} md={12} sm={12}>
                        <div className="d-flex justify-content-start">
                            <img
                                src={'media/company-logo/chat-bubble.png'}
                                alt="chat bubbles"
                                style={{ width: '100%', height: '100%' }}
                            />
                        </div>
                    </Col>
                </Row>
            </Col>
        </>
    )
};